// import './home.scss';

import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { login } from 'app/shared/reducers/authentication';
import LoginWidget from 'app/full_page/entry/login-widget';

export const EntryPage = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);
  const showModalLogin = useAppSelector(state => state.authentication.showModalLogin);
  const navigate = useNavigate();
  const pageLocation = useLocation();

  const handleLogin = (username, password, rememberMe = false) => dispatch(login(username, password, rememberMe));

  const handleClose = () => {
    navigate('/');
  };

  const { from } = pageLocation.state || { from: { pathname: '/', search: pageLocation.search } };
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }
  return <LoginWidget handleLogin={handleLogin} loginError={loginError} />;
};

export default EntryPage;
